import { Box, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <Box p={4} borderWidth="1px" borderRadius="lg" overflow="hidden">
      <Heading as="h2" size="lg" mb={4}>
        {t('privacy_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_intro')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_responsible_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_responsible_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_data_collected_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_data_collected_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_purpose_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_purpose_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_legitimation_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_legitimation_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_storage_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_storage_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_rights_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_rights_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_cookies_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_cookies_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('privacy_security_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('privacy_security_text')}
      </Text>
    </Box>
  );
};

export default Privacy;
